import Facade from "../../Facade";
import {Signals} from "@/Imports";
import ReelsConfig from "@/config/ReelsConfig";
import Utils from "@base/utils/Utils";
import Sound from "pixi-sound";
import Config from "@/config/Config";

export default new class SoundsHandling {
    constructor() {
        Signals.gameInited.add(this.onGameInited, this);
        Signals.spinBtnPressed.add(this.onSpinBtnPressed, this);
        // / Signals.columnClearFeelOnDown.add(this.onSpinStart, this)
        ///   Signals.reelJustTouchDown.add(this.onReelJustTouchDown, this)

        Signals.introFreespins.add(this.onIntroFreespins, this);
        Signals.buyFreespins.add(this.onIntroFreespins, this);
        Signals.outroFreespins.add(this.onOutroFreespins, this);
        Signals.introFreespinsComplete.add(this.onIntroFreespinsComplete, this);
        Signals.buyFreespinsComplete.add(this.onIntroFreespinsComplete, this);
        Signals.outroFreespinsComplete.add(this.onShowFreespinsOutroComplete, this);
        Signals.bonusGameComplete.add(this.onBonusGameComplete, this);
        Signals.bonusGame.add(this.onBonusGame, this);
        //Signals.startCountingUpWinnings.add(this.pauseBackMusic, this);
      //  Signals.hideCountingUpWinnings.add(this.resumeBackMusic, this);
        Signals.bonusCountDownComplete.add(this.onBonusCountdownComplete, this);
        Signals.bonusPhotoFinish.add(this.onBonusPhotoFinish, this);
        Signals.playSymbolRemove.add(this.symbolRemove, this)
        Signals.playWinLevel.add(this.playWinLevel, this)
        Signals.playSymbolDrop.add(this.onSymbolDrop, this)
        Signals.playSymbolCascade.add(this.onSymbolCascade, this)
        ///  Signals.startShowWinnings.add(this.onStartWinning, this)
        // Signals.startAnimation.add(this.onStartAnimationLine, this)
        Signals.startCountingUpWinnings.add(this.onStartCountingUpWinnings, this);
        Signals.showingBigWin.add(this.onShowBigWin, this);
        Signals.showBigWinStateChange.add(this.bigwinStateChange, this);
        Signals.startSpin.add(this.onSymbolDrop, this)
        Signals.showBigWinComplete.add(this.onShowBigWinComplete, this);
        Signals.winsCountupComplete.add(this.onWinsCountupComplete, this);
        Signals.startAnticipation.add(this.onAnticipation, this);
        Signals.stopAnticipation.add(this.stopAnticipation, this);
        Signals.skip.add(this.onSkip, this);
        Signals.skipForBuy.add(this.onSkip, this);
        Signals.skipCountingUpWinnings.add(this.onSkip, this);
        Signals.muteClick.add(this.onMuteClick, this);
        Signals.musicClick.add(this.onMusicClick, this);
        Signals.soundClick.add(this.onSoundClick, this);
        Signals.playTrail.add(this.playTrail, this);
        Signals.playMultiplierApply.add(this.playMultiplierApply, this);
        Signals.playMultiplierLand.add(this.playMultiplierLand, this);
        Signals.playMultiplierTrigger.add(this.playMultiplierTrigger, this);
        Signals.playScatterLand.add(this.playScatterLand, this);
        Signals.playMultiplierTickup.add(this.playMultiplierTickup, this);

        Signals.playBuyIncreas.add(this.playBuyBetIncreased, this);
        Signals.playBuyDecreaas.add(this.playBuyBetDecreased, this);
        Signals.playBuyMax.add(this.playBuyBetMax, this);

        Signals.btnClick.add(this.playBtnClick, this);

        this.musicVolume = 0.3;
        this.isFirstWild = false;

        const nameReelStop = "assets/sounds/dtd_reel_stop_1.mp3";
        const sound = Sound.add("default", nameReelStop);
        sound.filters = [new Sound.filters.StereoFilter(-1)];

        const sound1 = Sound.add("default", nameReelStop);
        sound1.filters = [new Sound.filters.StereoFilter(-0.5)];

        const sound2 = Sound.add("default", nameReelStop);
        sound2.filters = [new Sound.filters.StereoFilter(0)];

        const sound3 = Sound.add("default", nameReelStop);
        sound3.filters = [new Sound.filters.StereoFilter(0.5)];

        const sound4 = Sound.add("default", nameReelStop);
        sound4.filters = [new Sound.filters.StereoFilter(1)];

        const sound5 = Sound.add("default", nameReelStop);
        sound5.filters = [new Sound.filters.StereoFilter(1)];

        this.reelsStop = [sound, sound1, sound2, sound3, sound4, sound5];

        this.hasFocus = true;
        this.defaultMute = 1;
        this.isMuteSounds = true;
        this.isMuteMusic = true;
        const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
        });
        if (params.volume) {
            this.musicVolume = params.volume;
        }

        this.choiceBaseMusic = "mus_basegame";
    }

    onGameInited() {
        if (Facade.model.isFreespinsMode) {
            this.currentMusic = "mus_freespins";
        } else {
            this.currentMusic = this.choiceBaseMusic;
        }

        this.playMusic();
        this.isSpinning = false;
        this.reelStopCounter = 0;
        this.freeSpinsCounter = 0;
        this.isMute = false;
        this.completed = false;

        setInterval(() => this.checkBrowserOnFocus(), 1000);
    }

    onShowFreespinsOutroComplete() {
        this.currentMusic = this.choiceBaseMusic;
        if (!this.completed) this.playMusic();
        this.completed = true;
    }

    onBonusGame() {
        ///Facade.soundManager.stop (this.currentMusic)
        // this.currentMusic = 'uv_mus_bonusgame'
        // this.playMusic()
    }

    onBonusCountdownComplete() {
        /// Facade.soundManager.stop (this.currentMusic)
        /// this.currentMusic = 'uv_mus_bonusgame'
        /// this.playMusic()
    }

    onBonusPhotoFinish() {
        ///Facade.soundManager.stop (this.currentMusic)
    }

    onBonusGameComplete() {
        /*
        Facade.soundManager.play('uv_screen_impact', 1, false, 'default')
        if(!Facade.model.freespins) {
          this.currentMusic = 'mus_basegame'
          this.playMusic()
        }
         */
    }

    onIntroFreespins() {
        this.completed = false;
        Facade.soundManager.stop(this.currentMusic);
        Facade.soundManager.play("freespins_popup_intro", 1, false, "default");
        // this.currentMusic = "freespins_popup";
        // Facade.soundManager.play("freespins_popup_intro", 1, false, "default");
        // Facade.soundManager.pause(this.currentMusic);
        // setTimeout(() => {
        //     Facade.soundManager.play("freespins_popup", this.musicVolume, true, "default");
        // }, 1000);

    }

    onSymbolDrop() {
        Facade.soundManager.play("symbol_drop", 1, false, "default");
    }

    onSymbolCascade() {
        Facade.soundManager.play("symbol_cascade", 1, false, "default");
    }

    onOutroFreespins() {
        Facade.soundManager.stop(this.currentMusic);
        Facade.soundManager.play("winnings_popup", 1, false, "default");
    }

    onIntroFreespinsComplete() {
        Facade.soundManager.stop("freespins_popup");
        Facade.soundManager.stop(this.currentMusic);
        if (Facade.model.countAmountFreeBet > 0) {
            this.currentMusic = "mus_freespins";
        } else {
            this.currentMusic = this.choiceBaseMusic;
        }
        this.playMusic();
    }

    playMusic() {
        Facade.soundManager.play(this.currentMusic, this.musicVolume, true, "music");
    }

    pauseBackMusic(data) {
       // if (data.requireCounting && data.bigwin) {
            Facade.soundManager.pause(this.currentMusic);
    //    }
    }

    resumeBackMusic() {
        Facade.soundManager.resume(this.currentMusic);
    }

    onSoundClick(value) {
        this.isMuteSounds = value == 1 ? true : false;
        this.muteSounds(value);
    }

    muteSounds(value) {
        const group = Facade.soundManager.groups["default"];
        this.defaultMute = value;
        if (value) {
            group.volume = 1;
        } else {
            group.volume = 0;
        }
    }

    onMusicClick(value) {
        this.isMuteMusic = value == this.musicVolume ? true : false;
        this.muteMusic(value);
    }

    muteMusic(value) {
        const group = Facade.soundManager.groups["music"];
        if (value) {
            group.volume = 0.7;
        } else {
            group.volume = 0;
        }
    }

    onMuteClick(value) {
        this.onMusicClick(value);
        this.onSoundClick(value);
        /* this.isMute = !this.isMute
        if(this.isMute) {
          Facade.soundManager.muteAll()
        } else {
          Facade.soundManager.unmuteAll()
        }*/

        Signals.setMuteButtons.dispatch(value);
    }

    onSpinBtnPressed() {
        Facade.soundManager.play("spinPressed", 1, false, "default");
        //this.onSymbolDrop();
    }

    bigwinStateChange() {
        Facade.soundManager.play("big_win_state_change", 1, false, "default");
    }

    playBuyBetIncreased() {
        Facade.soundManager.play("bet_increase", 1, false, "default");
    }

    playBuyBetDecreased() {
        Facade.soundManager.play("bet_decrease", 1, false, "default");
    }

    playBuyBetMax() {
        Facade.soundManager.play("bet_max", 1, false, "default");
    }

    playBtnClick() {
        Facade.soundManager.play("generic_click", 1, false, "default");
    }


    onSpinStart() {
        this.totalBonusSymbols = 0;
        this.isFirstWild = false;

        if (this.isSpinning) {
            return;
        }
        this.isSkipped = false;
        this.isWiinnings = false;
        this.isSpinning = true;
        Facade.soundManager.play("spinning", 0.4, true, "default");
        if (Facade.model.isFreespinsMode) {
        }
    }

    onAnticipation() {
        Facade.soundManager.play("anticipationSound", 1, false, "default");
        Facade.soundManager.stop("spinning");
    }

    symbolRemove() {
        Facade.soundManager.play("symbol_remove", 1, false, "default");
    }

    stopAnticipation() {
        Facade.soundManager.stop("anticipationSound", 0.3, true, "default");
        //Facade.soundManager.stop("spinning");
    }

    onReelJustTouchDown(index) {
        let soundName;
        if (this.defaultMute == 1) {
            this.reelsStop[index].play();
        }
        this.reelStopCounter++;
        if (this.checkIndexOnReel(Config.symbolIndexes[1], index)) {
            Facade.soundManager.play("freespins" + this.freeSpinsCounter, 1.3, false, "default");
            this.freeSpinsCounter++;
        }
        /*
        let soundName = 'stopReel' + index

         if(this.checkIndexOnReel('3000', index)) {
          soundName = 'wildwolf'
        }

        this.totalBonusSymbols += this.checkIndexOnReelCnt('10', index)
        if(this.checkIndexOnReel('10', index)) {
          if(this.totalBonusSymbols >= 3) {
            soundName = 'uv_sym_bonus_3'
          }else if(this.totalBonusSymbols >= 2) {
            soundName = 'uv_sym_bonus_2'
          }else if(this.totalBonusSymbols >= 1) {
            soundName = 'uv_sym_bonus_1'
          }
        }
         if(this.checkIndexOnReel('10', index)) {
           if(index == 0) {
             soundName = 'uv_sym_bonus_1'
           }
        */
        if (soundName) {
            const sound = Facade.soundManager.play(soundName, 1, false, "default");
        }
        if (this.reelStopCounter === ReelsConfig.TOTAL_REELS) {
            this.reelStopCounter = 0;
            this.freeSpinsCounter = 0;
            this.isSpinning = false;
            Facade.soundManager.stop("anticipationSound");
            Facade.soundManager.stop("spinning");
        }
    }

    checkIndexOnReel(symbolIndex, reelIndex) {
        const data = Facade.model.reelsDataOrigin;
        for (let i = 0; i < data[reelIndex].length; i++) {
            if (data[reelIndex][i] == symbolIndex) {
                return true;
            }
        }
        return false;
    }

    checkIndexOnReelCnt(symbolIndex, reelIndex) {
        let cnt = 0;
        const data = Facade.model.reelsDataOrigin;
        for (let i = 0; i < data[reelIndex].length; i++) {
            if (data[reelIndex][i] == symbolIndex) {
                ++cnt;
            }
        }
        return cnt;
    }

    onStartAnimationLine(list) {
        if (this.checkIfSymbolsIsInPaylineWinline(list, Config.symbolIndexes[0])) {
            this.winSoundName = "win_payline_wild";
            Facade.soundManager.play(this.winSoundName, 1.5, false, "default");
        }
        if (this.checkIfSymbolsIsInPaylineWinline(list, Config.symbolIndexes[1])) {
            // this.winSoundName = 'scatter'
            //console.log('Sound scatter')
        }
        if (this.checkIfSymbolsIsInPaylineWinline(list, Config.symbolIndexes[2]) || this.checkIfSymbolsIsInPaylineWinline(list, Config.symbolIndexes[3])) {
            this.winSoundName = "win_payline_high2";
        }
        if (this.checkIfSymbolsIsInPaylineWinline(list, Config.symbolIndexes[4]) || this.checkIfSymbolsIsInPaylineWinline(list, Config.symbolIndexes[5])) {
            this.winSoundName = "win_payline_high1";
        }
        if (this.checkIfSymbolsIsInPaylineWinline(list, Config.symbolIndexes[6]) || this.checkIfSymbolsIsInPaylineWinline(list, Config.symbolIndexes[7])) {
            this.winSoundName = "win_payline_low2";
        }
        if (this.checkIfSymbolsIsInPaylineWinline(list, Config.symbolIndexes[8]) || this.checkIfSymbolsIsInPaylineWinline(list, Config.symbolIndexes[9])) {
            this.winSoundName = "win_payline_low1";
        }
        Facade.soundManager.play(this.winSoundName, 1.5, false, "default");
    }

    onStartWinning() {
        if (this.checkIfSymbolsIsInPayline(Config.symbolIndexes[0])) {
            this.winSoundName = "win_payline_wild";
            Facade.soundManager.play(this.winSoundName, 1.5, false, "default");
            return;
        }
        if (this.checkIfSymbolsIsInPayline(Config.symbolIndexes[1])) {
            // this.winSoundName = 'scatter'
            //console.log('Sound scatter')
        }
        if (this.checkIfSymbolsIsInPayline(Config.symbolIndexes[2]) || this.checkIfSymbolsIsInPayline(Config.symbolIndexes[3])) {
            this.winSoundName = "win_payline_high2";
            Facade.soundManager.play(this.winSoundName, 1.5, false, "default");
            return;
        }
        if (this.checkIfSymbolsIsInPayline(Config.symbolIndexes[4]) || this.checkIfSymbolsIsInPayline(Config.symbolIndexes[5])) {
            this.winSoundName = "win_payline_high1";
            Facade.soundManager.play(this.winSoundName, 1.5, false, "default");
            return;
        }
        if (this.checkIfSymbolsIsInPayline(Config.symbolIndexes[6]) || this.checkIfSymbolsIsInPayline(Config.symbolIndexes[7])) {
            this.winSoundName = "win_payline_low2";
            Facade.soundManager.play(this.winSoundName, 1.5, false, "default");
            return;
        }
        if (this.checkIfSymbolsIsInPayline(Config.symbolIndexes[8]) || this.checkIfSymbolsIsInPayline(Config.symbolIndexes[9])) {
            this.winSoundName = "win_payline_low1";
            Facade.soundManager.play(this.winSoundName, 1.5, false, "default");
        }
        //this.winSoundName = Facade.model.totalWin > 3 * Facade.model.totalBet ? 'win_payline_2' : 'win_payline_1'
        // if(Facade.model.isFreespinsMode) this.winSoundName = "freespins_popup"
        // freespins1
        /*
        if(this.checkIfSymbolsIsInPayline('3100')) {
          this.winSoundName = 'Wild'
        }

        Facade.soundManager.play(this.winSoundName, 1.5, false, 'default')
        */
    }

    checkIfSymbolsIsInPayline(index) {
        const winlines = Facade.model.winnings;
        const grid = Facade.model.reelsDataOrigin; ///?
        for (let i = 0; i < winlines.length; i++) {
            let line = winlines[i].payline.line;
            let payoutLength = winlines[i].payout.length;
            for (let j = 0; j < payoutLength; j++) {
                let s = line[j];
                if (grid[s[0]][s[1]] == index) {
                    return true;
                }
            }
        }
        return false;
    }

    checkIfSymbolsIsInPaylineWinline(currentWinlines, index) {
        const grid = Facade.model.reelsDataOrigin;
        let line = currentWinlines.payline.line;
        let payoutLength = currentWinlines.payout.length;
        for (let j = 0; j < payoutLength; j++) {
            let s = line[j];
            if (grid[s[0]][s[1]] == index) {
                return true;
            }
        }
        return false;
    }

    onStartCountingUpWinnings(data) {
        if (data.requireCounting) {
            Facade.soundManager.play("countup", 1, true, "default");
        } else {
            //this.resumeBackMusic();
            Facade.soundManager.play("END_OF_COUNTDOWN", 1, false, "default");
        }
    }

    onWinsCountupComplete(requireCounting) {
        Facade.soundManager.stop("countup");
        if (requireCounting && !this.isSkipped) {
            // setTimeout(() => {
            //     this.resumeBackMusic();
            // }, 2500);
            Facade.soundManager.play("END_OF_COUNTDOWN", 1, false, "default");
        }

        // else {
        //     this.resumeBackMusic();
        // }
    }

    onSkip() {
        // SHOULD BE FIXED
        return;
        this.isSkipped = true;
        Facade.soundManager.stop("countup");
        Facade.soundManager.stop(this.winSoundName);
    }

    onShowBigWin() {
        this.pauseBackMusic();
        this.bigwinStateChange()
        this.musicBigIntro = `win_big_intro`;
        Facade.soundManager.play(this.musicBigIntro, 0.3, true, "default");
        // Facade.soundManager.play("bigWinSound", 1, false, "default");
    }

    onShowBigWinComplete() {
        Facade.soundManager.stop(this.musicBigIntro);
        Facade.soundManager.play("win_big_end", 0.3, false, "default");
        this.resumeBackMusic();
    }

    showFSIntroMessage() {
        this.pauseBackMusic();
        Facade.soundManager.play("coinwin", 1, false, "default", () => {
            this.resumeBackMusic();
        });
    }

    playWinLevel(winlevel) {
        Facade.soundManager.play("win_level_" + winlevel.winlevel, 0.7, false, "default");
    }

    playRandomly(sound, min, max) {
        setTimeout(() => {
            Facade.soundManager.play(`${sound}${Utils.getRandomInt(1, this.ambientSettings[sound])}`, 1, false, "default");
            this.playRandomly(sound, min, max);
        }, Utils.getRandomInt(min, max));
    }

    playEvery(sound, volume, ms) {
        let interval = setInterval(() => {
            Facade.soundManager.play(sound, volume, false, "playEvery");
        }, ms);
        return interval;
    }

    //NEW SOUNDS MULTIPLIER
    playTrail() {
        Facade.soundManager.play("play_trail", 1, false, "default");
    };

    playMultiplierApply() {
        Facade.soundManager.play("multiplier_apply", 1, false, "default");
    };

    playMultiplierLand() {
        Facade.soundManager.play("multiplier_land", 1, false, "default");
    }

    playMultiplierTrigger() {
        Facade.soundManager.play("scatter_trigger", 1, false, "default");
    }

    playScatterLand() {
        Facade.soundManager.play("scatter_land", 1, false, "default");
    };

    playMultiplierTickup() {
        Facade.soundManager.play("multiplier_tickup", 1, false, "default");
    };

    checkBrowserOnFocus() {
        if (document.hasFocus ()) {
            if (! this.hasFocus) {
                if (this.isMuteSounds) {
                    this.muteSounds (1)
                }
                if (this.isMuteMusic) {
                    this.muteMusic (1)
                }
                this.hasFocus = true
                // Facade.soundManager.groups["default"];
            }
        } else {
            if (this.hasFocus) {
                this.muteSounds (0)
                this.muteMusic (0)
                this.hasFocus = false
            }
        }
    }

}
